import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from 'utils/constants/index'

export const getAllChatsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/chat/get-messages', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const getChatLanguageRoomsService = (params) => {
  return axiosInstance(METHOD_TYPES.get, '/chat/get-language-rooms', {}, {
    params,
    server: microServices.USER_URL
  })
}

export const sendChatService = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/chat/send-message', data, {
    server: microServices.USER_URL
  })
}
